import { sitesConstants } from '../../constants/sites';
import { slavesConstants } from '../../constants/slaves';
import { startSetSiteSettings } from '../../actions/app';
import { startSetSlaveSiteSettings } from '../../actions/slaves';
import { getSlaveId } from '../../components/Statistics/statisticsHelpers';

export const setSitesSettings = store => next => action => {
  if (action.type === sitesConstants.SET_SITES_SUCCESS) {
    store.dispatch(startSetSiteSettings());
  }
  if (action.type === slavesConstants.SET_SLAVE_SITES_SUCCESS) {
    store.dispatch(startSetSlaveSiteSettings(getSlaveId()));
  }

  return next(action);
};
